import { useCallback, useEffect, useState } from "react";
  import PropTypes from "prop-types";
import { useAuth } from "src/hooks/use-auth";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { Issuer } from "src/utils/auth";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { ADMIN_SERVER, API_SERVICE_BACKEND, selfURL, agentUrl, API_SERVICE_AUTOMATION_BACKEND } from "src/config";
import { isFeatureEnabled } from "src/utils/featureFlags";
import { getSessionStorage, setSessionStorage } from "src/utils/storage";

const loginPaths = {
  [Issuer.Amplify]: paths.auth.amplify.login,
  [Issuer.Auth0]: paths.auth.auth0.login,
  [Issuer.Firebase]: paths.auth.firebase.login,
  [Issuer.JWT]: paths.auth.jwt.login,
};

export const AuthGuard = (props) => {
  const { children } = props;
  const router = useRouter();

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const { isAuthenticated, issuer, user } = useAuth();
  const [checked, setChecked] = useState(false);
  let freeSubscription = user?.dbRef?.freeSubscription;
  let paymentWall = user?.dbRef?.isPaymentWall || false;
  let userPlanObj =
    user?.dbRef?.userSubscription &&
    Object.keys(user.dbRef.userSubscription).length > 0;

  let userSubscriptionId =
    user?.dbRef?.userSubscription &&
    Object.keys(user.dbRef.userSubscription).length > 0 &&
    user?.dbRef?.userSubscription?.subscriptionId;

  //console.log(
    // "userPlanObj====>",
  //   user,
  //   paymentWall,
  //   freeSubscription,
  //   userSubscriptionId
  // );

  const isPlan = {
    userPlan: userPlanObj,
    freeSub: freeSubscription,
    subscriptionId: userSubscriptionId == "free" ? true : false,
  };
  const getDomainFromLocation = () => {
    const domain = window.location.pathname || selfURL;
    return domain;
  };

  //console.log(window.location, 'window.location')



  const userWdata = getSessionStorage("userWdata")
  // //console.log(userWdata, 'userWdatauserWdatauserWdata=====')
  const domain2 = getDomainFromLocation();


  const check = useCallback(async () => {
    const userDataWorkspace = JSON.parse(userWdata)
    if (!isAuthenticated && !user) {
      // Preserve full URL so user returns to intended page after login (e.g. purchase?domain=xxx&emails=yyy)
      const searchParams = new URLSearchParams(window.location.search);
      const token = searchParams.get("token");
      const fullPath = pathname + (window.location.search ? window.location.search : "");

      if (token) {
        const params = new URLSearchParams(window.location.search);
        params.delete("token");
        const returnTo = pathname + (params.toString() ? `?${params.toString()}` : "");
        return navigate(`/auth-main/login/v2?token=${encodeURIComponent(token)}&returnTo=${encodeURIComponent(returnTo)}`);
      }

      // No token: still pass returnTo so user is sent back after login (with domain, emails, etc.)
      const returnTo = fullPath;
      return navigate(`/auth-main/login/v2?returnTo=${encodeURIComponent(returnTo)}`);
    }
    // //console.log(userDataWorkspace, 'userDataWorkspace')
    // const res = await axios.get(
    //   `${API_SERVICE_BACKEND}/getuserdetail/${user?.email}`
    // );

    const userData = user?.dbRef;
    const isVIPUser = userData?.isVIPUser;
    if (isAuthenticated && !userData?.signature && !isVIPUser) {
      navigate(`/signaturePage/${encodeURIComponent(userData.email)}`);
    }
    // if workspace logic is needed, keep it here
    else if (userData?.whiteLabelUserId) {
      // White-label sub-users skip paywall
      setChecked(true);
    } else {
      // Allow purchase/checkout pages through - user is completing a payment flow
      const isPurchaseOrCheckout = pathname?.includes("purchase") || pathname?.includes("checkout");
      if (isPurchaseOrCheckout) {
        setChecked(true);
      } else if (paymentWall) {
        navigate("/auth-main/pricingPage", { prev: pathname });
      } else if (isAuthenticated && !isPlan.userPlan && !isPlan.freeSub) {
        navigate("/auth-main/pricingPage", { prev: pathname });
      } else {
        if (isPlan.freeSub || isPlan.userPlan) {
          const isOnboardingEnabled = isFeatureEnabled("ONBOARDING");
          let isOnboardingCompleted = true; // Default to true so it doesn't block if API fails

          if (isOnboardingEnabled && user?.email) {
            try {
              const res = await axios.get(`${API_SERVICE_AUTOMATION_BACKEND}/onboarding?email=${user?.email}`, {headers: { 
              'x-user-id': user?.email
            }});
              isOnboardingCompleted = Boolean(res?.data?.data?.isCompleted);
            } catch (err) {
              console.error("Failed to fetch onboarding data:", err);
            }
          }

          if (isOnboardingEnabled && !isOnboardingCompleted) {
            if (pathname !== "/auth-main/onboarding") {
              navigate("/auth-main/onboarding");
            } else {
              setChecked(true); // Allow access to the onboarding page itself
            }
          } else {
            setChecked(true);
          }
        } else {
          navigate("/auth-main/pricingPage", { prev: pathname });
        }
      }
    }

  }, [isAuthenticated, issuer, router, userWdata]);

  // Only check on mount, this allows us to redirect the user manually when auth state changes
  useEffect(
    () => {
      check();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (!checked) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // authenticated / authorized.

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
